import { Injectable, InjectionToken } from '@angular/core';
import { CustomPointOfService, OccShopsByProductResponse, ShopsByProduct } from '@shop/const';
import { Converter } from '@spartacus/core';
import { OccShopConverter } from './occ-shop.converter';

@Injectable({ providedIn: 'root' })
export class OccShopNormalizer
  extends OccShopConverter
  implements Converter<OccShopsByProductResponse, ShopsByProduct>
{
  convert(source: OccShopsByProductResponse, target?: ShopsByProduct): ShopsByProduct {
    if (target === undefined) {
      target = {
        ...(source as any),
      };
    }

    if (target) {
      target.pointOfServices = (target.pointOfServices || target.pointsOfService)
        .filter((store: CustomPointOfService) => store.address)
        .map((store: CustomPointOfService) => ({
          ...store,
          addressFormatted: this.addressFormattedNormalize(store.address),
        }));
    }

    return target;
  }
}

export const SHOPS_NORMALIZER = new InjectionToken<Converter<any, ShopsByProduct>>('ShopsNormalizer');
